import {create} from 'zustand';
import {Store} from '../models/store.model';

type ActiveTab = 'list' | 'statistics';

interface StoresUIState {
  // Tab Management
  activeTab: ActiveTab;
  setActiveTab: (tab: ActiveTab) => void;

  // Modal States
  isDetailsModalOpen: boolean;
  isEditModalOpen: boolean;

  // Modal Actions
  openDetailsModal: () => void;
  closeDetailsModal: () => void;
  openEditModal: () => void;
  closeEditModal: () => void;

  // Selected Items
  selectedStoreId: string | null;
  editingStore: Store | null;
  deletingStoreId: string | null;

  // Selection Actions
  setSelectedStoreId: (id: string | null) => void;
  setEditingStore: (store: Store | null) => void;
  setDeletingStoreId: (id: string | null) => void;

  // Search and Filters
  searchQuery: string;
  paymentStatusFilter: string;
  cityFilter: string;
  districtFilter: string;

  // Filter Actions
  setSearchQuery: (query: string) => void;
  setPaymentStatusFilter: (status: string) => void;
  setCityFilter: (city: string) => void;
  setDistrictFilter: (district: string) => void;
  clearFilters: () => void;

  // Utility Actions
  reset: () => void;
}

export const useStoresUIStore = create<StoresUIState>((set) => ({
  // Tab Management
  activeTab: 'list',
  setActiveTab: (tab) => set({activeTab: tab}),

  // Modal States
  isDetailsModalOpen: false,
  isEditModalOpen: false,

  // Modal Actions
  openDetailsModal: () => set({isDetailsModalOpen: true}),
  closeDetailsModal: () => set({isDetailsModalOpen: false}),
  openEditModal: () => set({isEditModalOpen: true}),
  closeEditModal: () => set({isEditModalOpen: false}),

  // Selected Items
  selectedStoreId: null,
  editingStore: null,
  deletingStoreId: null,

  // Selection Actions
  setSelectedStoreId: (id) => set({selectedStoreId: id}),
  setEditingStore: (store) => set({editingStore: store}),
  setDeletingStoreId: (id) => set({deletingStoreId: id}),

  // Search and Filters
  searchQuery: '',
  paymentStatusFilter: '',
  cityFilter: '',
  districtFilter: '',

  // Filter Actions
  setSearchQuery: (query) => set({searchQuery: query}),
  setPaymentStatusFilter: (status) => set({paymentStatusFilter: status}),
  // Changing city resets the district (cascade) so a stale district can't linger.
  setCityFilter: (city) => set({cityFilter: city, districtFilter: ''}),
  setDistrictFilter: (district) => set({districtFilter: district}),
  clearFilters: () => set({
    searchQuery: '',
    paymentStatusFilter: '',
    cityFilter: '',
    districtFilter: ''
  }),

  // Utility Actions
  reset: () => set({
    activeTab: 'list',
    isDetailsModalOpen: false,
    isEditModalOpen: false,
    selectedStoreId: null,
    editingStore: null,
    deletingStoreId: null,
    searchQuery: '',
    paymentStatusFilter: '',
    cityFilter: '',
    districtFilter: ''
  })
}));
